import React from "react";
import { ButtonFileViewer, ButtonErrorWarning } from "src/components/Common/Button";
import { isArray } from "lodash";
import { truncateFileName } from "src/utils/common";
import { Spinner } from "reactstrap";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const SeriesData = ({ isLoading, serieData, handleViewFile, simulationData }) => {
  return isLoading ? (
    <div className="p-2 d-flex align-items-center justify-content-center w-100">
      <Spinner color="secondary" />
    </div>
  ) : (
    <div className="react-bootstrap-table table-detail overflow-auto">
      <table className="table">
        <thead className="table-secondary">
          <tr>
            <th className="width-by-px-60"></th>
            {serieData?.columns?.map((col, indexCol) => (
              <th key={indexCol}>{col.text}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {serieData?.data?.map((serieRow, indexSerie) => (
            <tr key={indexSerie}>
              <td>
                <div className="d-flex gap-2 align-items-center min-height-by-px-30 min-width-by-px-94">
                  <ButtonFileViewer
                    handleClick={() => handleViewFile({ isOpen: true, serieData: serieData?.data?.[0] })}
                    id={`${simulationData?.id}-${indexSerie}`}
                  />
                  <ButtonErrorWarning
                    isShow={serieRow?.errorList?.length > 0}
                    errorContent={serieRow?.errorList?.join("\n")}
                    id={`${simulationData?.id}-${indexSerie}`}
                  />
                </div>
              </td>
              {serieData?.columns?.map((col, indexCol) => {
                if (col?.dataField === "param_filename") {
                  return (
                    <td key={indexCol}>
                      <TooltipWrapper
                        tooltipText={serieRow?.paramList[col?.dataField]}
                        show={serieRow?.paramList[col?.dataField]?.length > 20}
                        id={`file-name-${serieData?.data?.id}`}
                      >
                        <span>{truncateFileName(serieRow?.paramList[col?.dataField], 20)}</span>
                      </TooltipWrapper>
                    </td>
                  );
                }
                return (
                  <td key={indexCol}>
                    {isArray(serieRow?.paramList[col?.dataField])
                      ? `[${serieRow?.paramList[col?.dataField].join(", ")}]`
                      : serieRow?.paramList[col?.dataField]}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SeriesData;
